import { Filder } from "@/project/documents/types"

export type DocumentsBreadcrumbState = {
  breadcrumb: Array<{
    id: number,
    name: string,
    basename: string,
    type: string,
    parentFolderId?: number | null,
    numbering?: string | null,
    children?: Array<Filder>,
    rights?: Object,
    specialFolder?: string,
  }>
}
export const state: DocumentsBreadcrumbState = {
  breadcrumb: [],
}
